<template>
    <div id="image-gallery" class="row mb-2">
        <div class="col-12 mb-2">
            <img id="img-focused" class="mx-auto d-block img-fluid" :src="current" alt="Focused Image">
        </div>
        <div class="col-12">
            <div class="row">
                <div v-if="images.length > 1" v-for="image in images" class="col">
                    <a @click="setImg(image)">
                        <img class="img-thumbnail" :src="image">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                current: '',
            }
        },
        methods: {
            setImg(url) {
                this.current = url;
            }
        },
        props: {
            images: Array
        },
        mounted() {
            this.current = this.images[0];
        }

    }
</script>
<style scoped>
.col{
    padding-left: 5px;
    padding-right: 5px;
}
#img-focused{
    max-height: 45vh;
}
</style>

